<template>
    <div>
        <progress-header />

        <template>
            <div class="container mt-4">
                <div class="row">
                    <div class="col-12 col-lg-9 mb-2">
                        <div class="card shadow-sm">
                            <form @submit.prevent="handleSubmit">
                                <div class="px-4 py-3 border-bottom">
                                    <h4 class="text-blue-600 font-weight-bold">
                                        {{ $t('taxi.pages.passengers.passengers_data') }}
                                    </h4>
                                </div>

                                <div class="px-4 py-3">
                                    <div
                                        v-if="idx < searchData.passengers_number"
                                        v-for="(passenger, idx) in passengers"
                                        :key="idx"
                                    >
                                        <passengers-passenger
                                            :passenger="passenger"
                                            :idx="idx"
                                            @update="onPassengerUpdated"
                                        />
                                    </div>
                                </div>
                                <div class="mb-4 pl-4">
                                    <button type="submit" class="btn btn-primary">
                                        {{ $t('next') }}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="col-12 col-lg-3">
                        <the-cart />
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import TheCart from './components/TheCart';
    import SearchBarInfo from './components/SearchBarInfo';
    import PassengersPassenger from './components/PassengersPassenger';
    import { mapGetters } from 'vuex';
    import ProgressHeader from './components/ProgressHeader';
    import AirportTransferRepository from '@repositories/AirportTransferRepository';
    import toastr from 'toastr';
    import {trackGA} from '@utilities/tracking';

    export default {
        components: {
            TheCart,
            SearchBarInfo,
            PassengersPassenger,
            ProgressHeader,
        },
        computed: {
            ...mapGetters({
                searchData: 'airportTransfersSearch/getSearchParameters',
                passengers: 'airportTransfersSearch/getPassengers',
                departureTravel: 'airportTransfersSearch/getDepartureTravel',
                returnTravel: 'airportTransfersSearch/getReturnTravel',
                sessionId: 'airportTransfersSearch/getSessionID',
                ticketPrices: 'airportTransfersSearch/getTicketPrices',
            }),
        },

        data() {
            return {

            };
        },

        created() {
            trackGA('checkout_progress', {
                checkout_step: 4,
                checkout_option: window.location.pathname,
            });

            let oldPassengers = this.passengers ? [...this.passengers] : null;

            if (this.searchData && this.searchData.passengers_number > 0) {
                this.$store.dispatch('airportTransfersSearch/setPassengers', this.createPassengers(this.searchData.passengers_number));
            }

            if (oldPassengers) {
                for (let i = 0; i < oldPassengers.length; i++) {
                    if (i < this.passengers.length) {
                        this.passengers[i] = oldPassengers[i];
                    }
                }
            }

            AirportTransferRepository.getTicketPrices({
                departure_id: this.departureTravel.id,
                return_id: this.returnTravel ? this.returnTravel.id : null,
                session_id: this.sessionId,
            }).then((data) => {
                this.$store.dispatch('airportTransfersSearch/setTicketPrices', data.data.ticketPrices);
            });
        },

        methods: {
            handleSubmit() {
                if (this.validatePhone()) {
                    this.$store.dispatch('airportTransfersSearch/setIsPassengersComplete', true).then(() => {
                        trackGA('set_checkout_option', {
                            'checkout_step': 2,
                            'checkout_option': 'passengers data',
                            // 'items': this.passengers.map(o => {return {id: 'ticket type', name: o.ticket_type};}),
                        });
                        this.$router.push({ name: 'airport-transfers.options' });
                    });
                }
            },

            createPassengers(quantity = 1) {
                const passengers = [];

                for (let i = 1; i <= quantity; i++) {
                    passengers.push(
                        this.passengerModel()
                    );
                }

                return passengers;
            },

            onPassengerUpdated(idx, data) {
                const passengers = JSON.parse(JSON.stringify(this.passengers));

                passengers[idx] = data;

                this.$store.dispatch('airportTransfersSearch/setPassengers', passengers);
            },

            passengerModel() {
                return {
                    first_name: null,
                    last_name: null,
                    phone: null,
                    ticket_type: 'normal',
                };
            },

            validatePhone() {
                let valid = true;
                let length_invalid = false;
                let plus_invalid = false;

                for (let idx in this.passengers) {
                    let invalid_phone = false;

                    if (this.passengers[idx].phone && this.passengers[idx].phone.length < 11) {
                        valid = false;
                        invalid_phone = true;
                        length_invalid = true;
                    }

                    if (this.passengers[idx].phone && this.passengers[idx].phone.length > 0 && this.passengers[idx].phone[0] !== '+') {
                        valid = false;
                        invalid_phone = true;
                        plus_invalid = true;
                    }

                    this.$set(
                        this.passengers,
                        idx,
                        Object.assign({}, this.passengers[idx], {invalid_phone})
                    );
                }

                if (!valid) {
                    if (length_invalid) {
                        toastr.error(this.$t('airport_transfers.pages.phone_length_error'));
                    }

                    if (plus_invalid) {
                        toastr.error(this.$t('phone_has_to_start_with_plus'));
                    }
                }

                return valid;
            },
        },
    };
</script>
